// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1_pT3","footer":"ModalError_footer__2DTp-"};